module.exports = __webpack_public_path__ + "static/media/left-carrot~bitYLBsk.56d4698c.svg";